import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Nav from "../../../Components/base/nav";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import RichTextEditor from "../../../Components/RichTextEditor"; // Ensure this import is correct
import ChooseImage from "../../../Components/Modal/ChooseImage";
import Sidebar from "../../../Components/base/sidebar";
import { BsEye } from "react-icons/bs";
import { Button } from "react-bootstrap";
import ActionBar from "../../../Components/Button/ActionBar";
import ContentForm from "../../../Components/Forms/ShowForm";
import Delete from "../../../Components/Button/Delete";
import SEOForm from "../../../Components/Forms/SEOForm";
import StoryDetails from "../../../Components/Forms/StoryDetails";
import TicketForm from "../../../Components/Forms/TicketForm";

export default function LongStory() {
  const location = useLocation();
  const id = location.state && location.state.id;
  const [ticket_group_code, setTicketGroupCode] = useState("");
  const [ticket_notes, setTicketNotes] = useState("");
  const [item, setItem] = useState<any | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [postID, setPostID] = useState<string | null>(null);
  const [role, setRole] = useState<string | null>(null);

  const handleTicketGroupCodeChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTicketGroupCode(e.target.value);
  };

  const handleTicketNotesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTicketNotes(e.target.value);
  };

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("ticket_group_code", ticket_group_code);
    formData.append("ticket_notes", ticket_notes);
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        alert("Authentication token not found!");
        setIsSubmitting(false);
        return;
      }

      if (postID) {
        await axios.post(
          `https://stagingbackend.pulp.ph/api/v1/pulpliveworld/ticket/${postID}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
      } else {
        const response = await axios.post(
          `https://stagingbackend.pulp.ph/api/v1/pulpliveworld/ticket`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        setPostID(response.data.id);
      }
      alert("Content Submitted Successfully !!");
      navigate("/view/post/ticket");
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      alert(`There was an error submitting the form!, ${error}`);
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 3000);
    }
  };

  // const handleSaveDraft = async () => {
  //     setIsSubmitting(true);

  //     const formData = new FormData();
  //     formData.append('category', category);
  //     formData.append('sub_category', sub_category);
  //     formData.append('title', title);
  //     formData.append('body', body);
  //     formData.append('seo_title', seo_title);
  //     formData.append('description', description);
  //     formData.append('sub_head', sub_head);
  //     formData.append('photo_by', photo_by);
  //     if (image) {
  //         formData.append('image', image);
  //     }
  //     if (imageUrl) {
  //         formData.append('imageUrl', imageUrl);
  //     }

  //     try {
  //         const authToken = localStorage.getItem('authToken');
  //         if (!authToken) {
  //             alert('Authentication token not found!');
  //             setIsSubmitting(false);
  //             return;
  //         }

  //         if (postID) {
  //             await axios.post(`https://cdn.pulp.ph/api/v1/longStory/save/${postID}`, formData, {
  //                 headers: {
  //                     'Content-Type': 'multipart/form-data',
  //                     Authorization: `Bearer ${authToken}`,
  //                 }
  //             });
  //         } else {
  //             const response = await axios.post(`https://cdn.pulp.ph/api/v1/longStory`, formData, {
  //                 headers: {
  //                     'Content-Type': 'multipart/form-data',
  //                     Authorization: `Bearer ${authToken}`,
  //                 }
  //             });
  //             setPostID(response.data.id);
  //         }
  //         alert('Draft Saved Successfully !!');
  //     } catch (error) {
  //         console.error('There was an error saving the draft!', error);
  //         alert(`There was an error saving the draft!, ${error}`);
  //     } finally {
  //         setIsSubmitting(false);
  //     }
  // };

  const handleViewLongStory = async () => {
    try {
      if (postID) {
        window.open(
          `https://pulpmagazine.com/article/long_story/${postID}`,
          "_blank"
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    setRole(storedRole);
  }, []);

  const handleDelete = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        // Handle the case where authToken is not available
        alert("Authentication token not found!");
        return;
      }

      const confirmDelete = window.confirm(
        "Are you sure you want to delete this content?"
      );
      if (!confirmDelete) {
        return; // If user cancels, do nothing
      }

      if (id) {
        await axios.delete(
          `https://stagingbackend.pulp.ph/api/v1/pulpliveworld/ticket/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
      }
      alert("Content Deleted Successfully !!"); // Handle success (e.g., show a success message or redirect)
      navigate("/view/post/ticket");
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      // Handle error (e.g., show an error message)
    }
  };
  return (
    <>
      <div className="w-full">
        <div className="Dashboard-container flex place-content-between">
          <h1 className="mt-5 font-semibold">Ticket Editor</h1>
          <ActionBar
            role={role}
            onSubmit={handleSubmit}
            onView={handleViewLongStory}
            isSubmitting={isSubmitting}
            isSaved={isSubmitting}
          />
        </div>
        <div className="container mt-5 pt-5 px-4 rounded bg-white">
          <TicketForm
            ticket_group_code={ticket_group_code}
            ticket_notes={ticket_notes}
            onTicketGroupCodeChange={handleTicketGroupCodeChange}
            onTicketNotesChange={handleTicketNotesChange}
          />
        </div>
      </div>
    </>
  );
}
